import { useState } from 'react';
// Tracks per-card expansion for a set of collapsible cards. State holds only the
// ids that DIFFER from the default, so a card absent from state (e.g. a freshly
// loaded search) reads as the default without seeding — which also means a new
// search's cards fall back to the default automatically.
export const useExpandableGroups = (ids, options = {}) => {
    const { defaultExpanded = true } = options;
    const [toggled, setToggled] = useState(new Set());
    const toggle = (id) => setToggled(prev => {
        const next = new Set(prev);
        if (next.has(id)) {
            next.delete(id);
        }
        else {
            next.add(id);
        }
        return next;
    });
    const isExpanded = (id) => toggled.has(id) ? !defaultExpanded : defaultExpanded;
    return {
        isExpanded,
        toggle,
        expandAll: () => setToggled(defaultExpanded ? new Set() : new Set(ids)),
        collapseAll: () => setToggled(defaultExpanded ? new Set(ids) : new Set()),
        allExpanded: ids.every(isExpanded)
    };
};
